import { render, staticRenderFns } from "./AttendanceIndex.vue?vue&type=template&id=2bcc2258&scoped=true&"
import script from "./AttendanceIndex.vue?vue&type=script&lang=js&"
export * from "./AttendanceIndex.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceIndex.vue?vue&type=style&index=0&id=2bcc2258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc2258",
  null
  
)

export default component.exports